// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"7d8363be","335":"1a7bb496","662":"eb2df193","712":"70ba4d57","811":"ef936bac"}[chunkId] + ".chunk.css";
};